// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3I50s","sendOtp":"AuthorizeToLogin_sendOtp__2q-bd"};